import { metricKeys } from '@pulse/metrics';
import { getFilterFromRules } from '@utils';
import { DATASET } from '@utils/constants';
import { getPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import getGranularity from '@utils/granularity';

export const defaultQuery = {
  type: 'timeseries',
  dataset: DATASET,
  metrics: [metricKeys.Attempts, metricKeys.Plays],
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  options: {
    withTotals: true,
  },
};

export default (config) => {
  const { filterBars, savedFilters, metricList: compareMetricList, interval, allMetrics } = config;

  const mergedFilters = [...filterBars, ...savedFilters];

  // TODO: this doesn't look right. query all metrics if there are no compare metrics?
  let metricList = compareMetricList.length ? compareMetricList : Object.keys(allMetrics);

  metricList = metricList
    .reduce((agg, metric) => {
      agg.push(metric);
      const invertedMetric = getPercentageMetricByKey({ metricKey: metric });
      if (invertedMetric) {
        agg.push(invertedMetric);
      }
      return agg;
    }, [])
    .sort();

  let queries: any = mergedFilters.map((item) => {
    let flexFilter = false;
    Object.values(item.filters).forEach((rule) => {
      if (Object.keys(rule).includes('_order')) {
        flexFilter = true;
      }
    });
    const filters = getFilterFromRules(item.filters, flexFilter);
    const granularityVal =
      interval.granularity || getGranularity({ from: interval.from, to: interval.to });
    return {
      interval: `${interval.from}/${interval.to}`,
      metrics: metricList,
      filter: filters.rule,
      granularity: granularityVal,
    };
  });

  if (!queries.length) {
    queries = {
      interval: `${interval.from}/${interval.to}`,
      metrics: metricList,
      granularity: getGranularity({
        from: interval.from,
        to: interval.to,
        minuteGranularity: true,
      }),
    };
  }

  if (!Array.isArray(queries)) {
    queries = [queries];
  }

  queries = queries.map((item) => {
    const Q = { ...defaultQuery, ...item };
    return { queries: [Q] };
  });

  return queries;
};
